import { Checkbox, FormControlLabel, Grid } from '@mui/material'
import { SxProps, Theme, useTheme } from '@mui/material/styles'

import { useEditConfig } from '@providers/EditConfigProvider'

import { CONFIG_MENU_OPTION, ENTITY_CONFIG_TYPE } from '@constants'

type ExportAllCheckboxProps = {
  label?: string
  sx?: SxProps<Theme> | undefined
}

export const ExportAllCheckbox = ({ label, sx }: ExportAllCheckboxProps) => {
  const theme = useTheme()

  const { configMenuOption, isExportAllSelected, handleSelectExportAll, entityType } =
    useEditConfig()

  const shouldShowExport = configMenuOption === CONFIG_MENU_OPTION.EXPORT
  const shouldShowDictionaryEdit =
    entityType === ENTITY_CONFIG_TYPE.DICTIONARIES && configMenuOption === CONFIG_MENU_OPTION.EDIT

  if (!shouldShowExport && !shouldShowDictionaryEdit) {
    return null
  }

  const checkboxLabel =
    configMenuOption && configMenuOption?.charAt(0).toUpperCase() + configMenuOption?.slice(1)

  return (
    <Grid container item justifyContent={'flex-end'}>
      <FormControlLabel
        label={label || `${checkboxLabel} all CFG`}
        control={
          <Checkbox
            checked={isExportAllSelected}
            sx={{
              color: theme.palette.grey['800'],
              '&.Mui-checked': {
                color: theme.palette.grey['800'],
              },
              ...sx,
            }}
            onChange={(_, checked) => handleSelectExportAll(checked)}
          />
        }
      />
    </Grid>
  )
}
